'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dateStringToDate(date) {
	var split = date.split('/');
	var year = +split[2];
	if (year < 100) {
		year += 2000;
	}
	var month = +split[1] - 1;
	var day = +split[0];
	return new Date(year, month, day);
}

var _class = function () {
	/*@ngInject*/
	function _class(todaysSessions, calendarDate, $http, ColorFinder, HourFinder, StartFinder) {
		_classCallCheck(this, _class);

		this.todaysSessions = todaysSessions;
		this.counts = {
			'blue': 0,
			'green': 0,
			'dark green': 0,
			'dark blue': 0,
			'purple': 0,
			'dark purple': 0,
			'orange': 0,
			'dark orange': 0,
			'red': 0
		};
		this.total = 0;
		this.calendarDate = calendarDate;
		this.$http = $http;
		this.lastWrite = null;
		this.lastWriteId = null;
		this.loaded = false;
		this.saved = false;
		this.ColorFinder = ColorFinder;
		this.HourFinder = HourFinder;
		this.StartFinder = StartFinder;
	}

	_createClass(_class, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.$http.get('/api/colour-writes').then(function (res) {
				var data = res.data;

				if (!data || data.length === 0) {
					return;
				}

				var found = data.find(function (datum) {
					return new Date(datum.calendarDate).getTime() === _this.calendarDate.getTime();
				});

				if (found) {
					_this.lastWrite = found.dateCreated;
					_this.lastWriteId = found._id;
				};

				_this.loaded = true;
			});

			this.todaysSessions.forEach(function (session) {

				var instance = session._instance;

				if (session.overwriteVisibility && session.overwriteVisibility[instance]) {
					return;
				}

				var _date = dateStringToDate(session.date);
				var day = _date.getDay();

				var time = _this.StartFinder(session, instance);

				var isWeekend = day === 0 || day === 6;

				if (!isWeekend && time < 930) {
					return;
				}

				var color = _this.ColorFinder(session, instance);
				var hours = _this.HourFinder(session, instance) / 60;

				if (typeof _this.counts[color] !== 'undefined') {
					_this.counts[color] += hours;
				}
			});

			this.total = Object.keys(this.counts).reduce(function (previous, key) {
				if (key === 'red') {
					return previous;
				}

				return previous + _this.counts[key];
			}, 0);
		}
	}, {
		key: 'writeDB',
		value: function writeDB() {
			var _this2 = this;

			console.log('fired');
			var data = {
				data: this.counts,
				calendarDate: this.calendarDate
			};

			if (this.lastWriteId) {
				this.$http.delete('/api/colour-writes/' + this.lastWriteId);
			}

			this.$http.post('/api/colour-writes', data).then(function (res) {
				_this2.lastWrite = new Date();
				_this2.saved = true;
			});
		}
	}]);

	return _class;
}();

exports.default = _class;


// WEBPACK FOOTER //
// ./client/app/calendar/colour-count/colour-count.controller.js